export { default } from "./getScrollbarSize.mjs";